import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Chip, FormHelperText, Grid, InputAdornment } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import Api from '../../Api';
import {
    IComboBoxOption, IMaterialDescriptionComboBoxOption,
    IMaterialDescriptionFormSection, IMaterialItem, IMaterialSiteComboBoxOption, MaterialContext
} from '../../interfaces';
import { Values } from '../../utils';
import { DatePicker } from '../Shared/FormControls/DatePicker';


export const MaterialDescriptionFormSection: React.SFC<IMaterialDescriptionFormSection> = ({
    context,
    isContract,
    isUpdate,
    material,
    onUpdate,
    ...props
}: IMaterialDescriptionFormSection) => {



    const [descriptionSuggestions, setDescriptionSuggestions] = useState<IComboBoxOption[]>([]);
    const [ownerSuggestions, setOwnerSuggestions] = useState<IComboBoxOption[]>([]);

    const updateDescriptionSuggestions = (value: string) => {

        if (value.length > 2) {
            Api.Materials.Search.description(value).then((data) => {
                setDescriptionSuggestions((data as string[])
                    .map(x => { return { id: x, value: x } }));
            })
        } else {
            setDescriptionSuggestions([]);
        }
    }

    const updateOwnerSuggestions = (value: string) => {

        if (value.length > 2) {


            Api.Materials.Search.owner(value).then((data) => {
                setOwnerSuggestions((data as string[])
                    .map(x => { return { id: x, value: x } }));
            })

        } else {
            setOwnerSuggestions([]);
        }
    }

    const getL2Descriptions = () => {

        let currentL1 = descriptions.filter(x => x.value === material.l1?.value)[0];

        if (currentL1 && currentL1.getL2Descriptions) {
            return currentL1.getL2Descriptions;
        }
        else return [];
    }

    const filteredSpareTypes = (): IComboBoxOption[] => {

        if (isContract)
            return spareTypes.filter(x => (x.value === "Leased" || x.value === "Contractual"));
        else
            return spareTypes.filter(x => (x.value !== "Leased" && x.value !== "Contractual"));

    }

    const siteDisabled = context === MaterialContext.MaterialRowApproved;

    const [spareTypes, setSpareTypes] = useState<IComboBoxOption[]>([]);
    const [vehicleClasses, setVehicleClasses] = useState<IComboBoxOption[]>([]);
    const [descriptions, setDescriptions] = useState<IMaterialDescriptionComboBoxOption[]>([]);
    const [sites, setSites] = useState<IMaterialSiteComboBoxOption[]>([]);
    const [statuses, setStatuses] = useState<IComboBoxOption[]>([]);
    const [units, setUnits] = useState<IComboBoxOption[]>([]);

    useEffect(() => {

        let requiredValues = [
            ["sparetypes", setSpareTypes],
            ["vehicleclasses", setVehicleClasses],
            ["descriptions", setDescriptions],
            ["materialStates", setStatuses],
            ["uoms", setUnits]
        ];

        //we only need to get values if site is editable
        if (!siteDisabled)
            requiredValues.push(["sites", setSites])

        requiredValues.forEach(x => Values.setValues(x[0] as string, x[1]));

    }, [siteDisabled]);

    useEffect(() => {

    }, [material])

    return (
        <Accordion
            defaultExpanded={true}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <DialogContentText color="primary">
                    Material Description
                </DialogContentText>
            </AccordionSummary>
            <AccordionDetails>

                <Grid container >
                    <Grid item={true} xs={6} sx={{ p: 1 }} >
                        <Autocomplete

                            id="material-spare-type"
                            options={filteredSpareTypes().map(x => x.value)}
                            value={material.spareType?.value || null}
                            onChange={(_, value) => onUpdate("spareType", { value, id: spareTypes.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Spare Type"
                                required
                                helperText="What type of spare is being added"

                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={6} sx={{ p: 1 }}>
                        <Autocomplete
                            id="material-vehicle-classes"
                            multiple
                            options={vehicleClasses.map(opt => opt.value)}
                            value={material.vehicleClasses?.map(x => x.value)}

                            onChange={(_, value) => onUpdate("vehicleClasses", value.map(v => { return { value: v, id: vehicleClasses.filter(x => x.value === v)[0].id } }) as IMaterialItem[])}
                            renderTags={(value: (string | null | undefined)[], getTagProps) =>

                                (value as string[]).map((option: string, index: number) => (
                                    <Chip
                                        variant="filled"
                                        color="primary"
                                        label={option}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => <TextField
                                {...params}
                                label="Vehicle Class"
                                required
                                inputProps={{
                                    ...params.inputProps,
                                    required: material.vehicleClasses?.length === 0
                                }}
                                helperText="Choose one or multiple classes"

                            />}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item={true} xs={12} sx={{ p: 1 }}>
                        <FormHelperText>Level 1 & 2 taken from  MP/TT0028 - System Codes For Traction And Rolling Stock Iss11</FormHelperText>
                    </Grid>
                    <Grid item={true} xs={6} sx={{ p: 1 }}>
                        <Autocomplete
                            id="material-l1"
                            options={descriptions.map(opt => opt.value)}
                            value={material.l1?.value || null}
                            onChange={(_, value) => onUpdate("l1", { value, id: descriptions.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Level 1 Description"
                                required


                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={6} sx={{ p: 1 }}>
                        <Autocomplete
                            id="material-l2"
                            options={getL2Descriptions()?.map(opt => opt.value as string)}
                            value={material.l2?.value || null}
                            onChange={(_, value) => onUpdate("l2", { value, id: getL2Descriptions().filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Level 2 Description"
                                required


                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={12} sx={{ p: 0.5 }}>
                        <Autocomplete
                            id="material-l3"
                            options={descriptionSuggestions.map(opt => opt.value as string)}
                            freeSolo

                            filterOptions={(x) => x}

                            value={material.l3}

                            onChange={(_, value) => onUpdate("l3", value)}
                            onInputChange={(event: object, value: string, reason: string) => {
                                if (reason === 'input') {
                                    updateDescriptionSuggestions(value);
                                    onUpdate("l3", value)
                                }
                            }}

                            renderInput={(params) => <TextField
                                {...params}
                                label="Level 3 Description"
                                required

                            />}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ mt: 2 }}>
                    <Grid item={true} xs={2} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            required
                            variant="outlined"
                            label="Quantity"
                            type="number"
                            inputProps={{ min: 1 }}
                            value={material.quantity}
                            onChange={(e) => onUpdate("quantity", e.currentTarget.value)}
                            disabled={(isContract && isUpdate)}
                        />
                    </Grid>
                    <Grid item={true} xs={2} sx={{ p: 0.5 }}>
                        <Autocomplete
                            id="material-l2"
                            options={units.map(opt => opt.value as string)}
                            value={material.unitOfQuantity?.value || null}
                            onChange={(_, value) => onUpdate("unitOfQuantity", { value, id: units.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Unit of quantity"
                                required
                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>

                        <Autocomplete
                            id="material-status"
                            options={statuses.map(x => x.value)}
                            value={material.state?.value || null}
                            onChange={(_, value) => onUpdate("state", { value, id: statuses.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Status"
                                required
                                helperText="What is the condition of the material"

                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        {/* HERE */}

                        <DatePicker
                            label="Expiry Date"
                            value={material.partExpiry}
                            onChange={(value) => onUpdate("partExpiry", value)}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            required
                            InputProps={{ endAdornment: <InputAdornment position="end" >Kg</InputAdornment> }}
                            inputProps={{ min: 0.01, step: 'any' }}
                            variant="outlined"
                            type="number"
                            label="Estimated Weight"
                            value={material.weightEstimate}
                            onChange={(e) => onUpdate("weightEstimate", e.currentTarget.value)}
                            helperText="Weight per quantity"
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>

                        <Autocomplete
                            id="material-site"
                            options={sites.map(x => x.value)}
                            value={material.site?.value || null}
                            onChange={(_, value) => onUpdate("site", { value, id: sites.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Site"
                                required

                                disabled={siteDisabled}

                                helperText={siteDisabled ?
                                    "Site can be amended under 'Location'"
                                    : "Where the material will be stored"
                                }

                            />}
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>

                        <Autocomplete
                            id="material-owned-by"
                            options={ownerSuggestions.map(opt => opt.value as string)}
                            freeSolo
                            filterOptions={(x) => x}
                            value={material.ownedBy}
                            onChange={(_, value) => onUpdate("ownedBy", value)}
                            onInputChange={(event: object, value: string, reason: string) => {
                                if (reason === 'input') {
                                    updateOwnerSuggestions(value);
                                    onUpdate("ownedBy", value)
                                }
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Owned By"
                                required

                            />}
                        />


                    </Grid>
                </Grid>

            </AccordionDetails>
        </Accordion>
    );
}